import { appendIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'

import {
  useOpenAvailabilityModal,
  useOpenChangeAvailabilityStatusModal
} from '../../../utils/routes/modals/modalsActions'

export const useOpenAvailabilityDetailsAction = item => {
  const openAvailabilityModal = useOpenAvailabilityModal()

  return {
    click: () => openAvailabilityModal(item)
  }
}

export const useChangeAvailabilityStatusAction = item => {
  const canEdit = useSessionPermission('editPlaceAvailabilityStatus')
  const openChangeStatusModal = useOpenChangeAvailabilityStatusModal()

  return {
    hasPermission: canEdit,
    click: () =>
      openChangeStatusModal({ placeId: item.id, placeName: item.name, currentStatus: item.availabilityStatus })
  }
}

export const useAvailabilityActionsList = item => {
  const { t } = useTranslation('common')
  const details = useOpenAvailabilityDetailsAction(item)
  const changeStatus = useChangeAvailabilityStatusAction(item)

  return [
    [
      {
        value: t('seeDetails'),
        icon: 'BsSearch',
        onClick: details.click
      },
      ...appendIf(changeStatus.hasPermission, {
        value: t('changeStatus'),
        icon: 'BsArrowRepeat',
        onClick: changeStatus.click
      })
    ],
    false
  ]
}
